import { memo, useCallback } from 'react';
import { AnimatedCoinsEllipseProps } from './AnimatedCoinsEllipse.types';
import { AnimatedCoinVariant } from './AnimatedCoin/AnimatedCoin.types';
import { getMiddleX } from './AnimatedCoinsEllipse.utils';
import AnimatedCoin from './AnimatedCoin/AnimatedCoin';
import Box from '../Box/Box';

const ANIMATED_COINS_COUNT = 10;

function AnimatedCoinsEllipse({
  fromPoint,
  toPoint,
  onAnimationFinish,
}: AnimatedCoinsEllipseProps) {
  const distance = getMiddleX(toPoint) - getMiddleX(fromPoint);
  const duration = Math.max(500, Math.min(1000, 1000 * (distance / 300)));
  const rx = distance / 2;
  const cx = getMiddleX(toPoint) - rx;
  const cy = toPoint.y + toPoint.height;

  const handleAnimationFinish = useCallback(
    (index: number) => {
      if (index === ANIMATED_COINS_COUNT - 1) {
        onAnimationFinish?.();
      }
    },
    [onAnimationFinish],
  );

  return (
    <Box absoluteFill pointerEvents="none" zIndex={1}>
      {Array.from({ length: ANIMATED_COINS_COUNT }, (_, index) => (
        <AnimatedCoin
          key={index}
          cx={cx}
          cy={cy}
          rx={rx}
          ry={40}
          index={index}
          fromAngle={Math.PI}
          toAngle={Math.PI * 2}
          variant={((index % 8) + 1) as AnimatedCoinVariant}
          duration={duration}
          delay={index * ((duration / 1000) * 100)}
          onAnimationFinish={handleAnimationFinish}
        />
      ))}
    </Box>
  );
}

export default memo(AnimatedCoinsEllipse);
